module.exports = __webpack_public_path__ + "static/img/value-bg.cf2a37de.png";